import { render, staticRenderFns } from "./LaboratoryProfile.vue?vue&type=template&id=6ea4d035&scoped=true&"
import script from "./LaboratoryProfile.vue?vue&type=script&lang=js&"
export * from "./LaboratoryProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4d035",
  null
  
)

export default component.exports